import { render, staticRenderFns } from "./AreaEmbargadaRs.vue?vue&type=template&id=5eac6738&lang=pug"
import script from "./AreaEmbargadaRs.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaRs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports